import { FaHeart } from "react-icons/fa"
import { useAppSelector } from "../../app/hooks"
import MeterBar from "../../components/MeterBar"
import { useGameTriggerContext } from "../../hooks/GameTriggers"
import { selectGamePhysicalHealth } from "./gameSlice"
import { Icon } from "@chakra-ui/react"

export const PhysicalHealthMeter = () => {
  const turnPhysicalHealth = useAppSelector(selectGamePhysicalHealth)
  const { physicalHealthModifier } = useGameTriggerContext()

  return (
    <MeterBar
      label="Health"
      value={turnPhysicalHealth}
      max={100}
      icon={<Icon boxSize={6} as={FaHeart} />}
      modifier={physicalHealthModifier}
      color="#f87171"
    />
  )
}
